import { cacheAdapterEnhancer } from 'axios-extensions';
import axios from 'axios';

const http = axios.create({
    // cache will be enabled by default
    adapter: cacheAdapterEnhancer(axios.defaults.adapter)
});

const base = "https://ws2.nongmoproject.org/";
// Useful! https://ws2.nongmoproject.org/api/v1/flush
// Useful! http://ws2.nongmoproject.local/api/v1/flush
// const base = "http://ws2.nongmoproject.local/";

const googleKey = "AIzaSyBx6aHKUTkoyJ5AT2dYnNYj07LVa7mP17I";

export default {
    isZipOrCityState(value) {
        if (
            /(^\d{5}([\-]\d{4})?$)/.test(value) ||
            /(^[A-Za-z][0-9][A-Za-z]\s?[0-9][A-Za-z][0-9]$)/.test(value) ||
            /(^[A-Za-z0-9 ]*,[A-Za-z0-9 ]*$)/.test(value)
        ) return true;
        else return false;
    },
    getCategories() {
        return http
            .get(base + 'api/v1/get_categories')
            .then(response => { return response })
    },
    getBrandproductsByCategory(cat_id, page) {
        return http
            .get(base + 'api/v1/get_brands_products_by_category?catid=' + cat_id + '&page=' + page)
            .then(response => { return response })
    },
    getProductsForBrand(brand_id, cat_id) {
        return http
            .get(base + 'api/v1/get_products_for_brand?catid=' + cat_id + '&brandid=' + brand_id)
            .then(response => { return response })
    },
    getBrandproductsByCategoryAndAlpha(cat_id, alpha, page) {
        return http
            .get(base + 'api/v1/get_brands_products_by_category_and_alpha?catid=' + cat_id + '&alpha=' + alpha + '&page=' + page)
            .then(response => { return response })
    },
    getBrandproductsById(brand_id) {
        return http
            .get(base + 'api/v1/get_brands_products_by_id?brand_id=' + brand_id )
            .then(response => { return response })
    },
    getBrandproductsByAlpha(alpha, page) {
        return http
            .get(base + 'api/v1/get_brands_by_alpha?alpha=' + alpha + '&page=' + page)
            .then(response => { return response })
    },
    getBrandproducts(page) {
        return http
            .get(base + 'api/v1/get_brands?page=' + page)
            .then(response => { return response })
    },
    getBrandproductsByKeyword(keyword, page) {
        return http
            .get(base + 'api/v1/get_brands_products_by_keyword?keyword=' + keyword + '&page=' + page)
            .then(response => { return response })
    },
    getProductsForBrandByKeyword(brand_id, keyword) {
        return http
            .get(base + 'api/v1/get_products_for_brand_by_keyword?keyword=' + keyword + '&brandid=' + brand_id)
            .then(response => { return response })
    },
    getRetailers(page, alphaselect, typeselect, stateselect, keyword) {
        if (alphaselect == undefined) alphaselect = '';
        if (typeselect == undefined) typeselect = '';
        if (stateselect == undefined) stateselect = '';
        if (keyword == undefined) keyword = '';
        if (alphaselect != '') {
            return http
                .get(base + 'api/v1/get_retailers_by_alpha?page=' + page + '&alpha=' + alphaselect + "&condense=1")
                .then(response => { return response })
        } else if (typeselect != '') {
            return http
                .get(base + 'api/v1/get_retailers_by_type?page=' + page + '&type=' + typeselect)
                .then(response => { return response })
        } else if (stateselect != '') {
            return http
                .get(base + 'api/v1/get_retailers_by_state?page=' + page + '&state=' + stateselect)
                .then(response => { return response })
        } else if (keyword != '') {
            // determine if we want to use geolocation or raw keyword
            if (this.isZipOrCityState(keyword)) {
                let url = 'https://maps.googleapis.com/maps/api/geocode/json';
                url += "?key=" + encodeURIComponent(googleKey);
                url += "&address=" + encodeURIComponent(keyword);
                return http.get(url)
                    .then(response => {
                        // console.log(response.status);
                        if ((response.status == 200) && (response.data.status == "OK")) {
                            // console.log(response.data.results[0].geometry.location);
                            let lat = response.data.results[0].geometry.location.lat;
                            let lng = response.data.results[0].geometry.location.lng;
                            return http
                                .get(base + 'api/v1/get_retailers_closest_to?lat=' + lat + '&lng=' + lng + "&limit=100&within=100")
                                .then(response => {
                                    response.data.meta = {
                                        total: response.data.data.length,
                                        current_page: 1,
                                        from: 1,
                                        last_page: 1,
                                        to: response.data.data.length,
                                    };
                                    return response
                                })
                        } else {
                            return { data: [], meta: { total: 0 } };
                        }
                    })
            } else {
                return http
                    .get(base + 'api/v1/get_retailers_by_keyword?page=' + page + '&keyword=' + keyword)
                    .then(response => { return response })
            }
        } else {
            return http
                .get(base + 'api/v1/get_retailers?page=' + page + '&condense=1')
                .then(response => {
                    return response
                })
        }
    },
    getRetailersInGroup(retailer_group_id) {
        return http
            .get(base + 'api/v1/get_retailers_by_group?rgid=' + retailer_group_id)
            .then(response => { return response })
    },

    getClosestRetailers(position) {
        return http
            .get(base + 'api/v1/get_retailers_closest_to?lat=' + position.lat + '&lng=' + position.lng + '&limit=50&within=5?limit=50')
            .then(response => { return response })
    },



    /** RETAILERS

        // http://ws2.nongmoproject.local/api/v1/get_retailers_closest_to?lat=32.222607&lng=-110.974711&limit=50&within=5?limit=50
            Route::get('/v1/get_retailers_closest_to', 'ApiController@get_retailers_closest_to');

        // http://ws2.nongmoproject.local/api/v1/get_retailers_by_keyword?keyword=conspiracy&page=1
        Route::get('/v1/get_retailers_by_keyword', 'ApiController@get_retailers_by_keyword');

        // http://ws2.nongmoproject.local/api/v1/get_retailers_by_type?type=supporting=0&$page=1 // or nongmomonth
        Route::get('/v1/get_retailers_by_type', 'ApiController@get_retailers_by_type');

        // http://ws2.nongmoproject.local/api/v1/get_retailers?page=50
        Route::get('/v1/get_retailers', 'ApiController@get_retailers');

        // http://ws2.nongmoproject.local/api/v1/get_retailers_by_group?page=50&rgid=2
        Route::get('/v1/get_retailers_by_group', 'ApiController@get_retailers_by_group');

     **/

}
